import React from 'react'
import * as Yup from 'yup';
import {
  CaseForms,
  CaseMutationType,
  CaseStepperType,
  ComplexCaseType,
} from "../../../helpers/enums";
import {
  TranslatedText,
  removeRequiredStep,
  removeDeletedLayoutFields, getValidationObject,
} from '../../../helpers/helpers';
import PrivacyPolicy from "../../common/PrivacyPolicy/PrivacyPolicy";


let sign = false;
const InfoLabel = ({label = "Test label"}) => {
  return (
    <div className="info-label">
      <span className="gc-icon-functional-attention-2-col">
        <span className="path1"/>
        <span className="path2"/>
      </span>
      <p>{label}</p>
    </div>
  );
};
const SignDigitalTitleEmailContent = ({label = ''}) => {
  return (
    <>
      <h3>{label}</h3>
      <br/>
    </>
  )
}
const startEventDataLayer = () => {window.dataLayer.push({"event": "pratica", "tipo": CaseForms.DomiciliazioneBancariaComplex ,"step": "avvio"})}
let model = {
  formId: CaseForms.ModificaDomiciliazioneBancariaComplex,
  formField: {
    // step 1.1
    selezioneContratto: {
      name: 'selezioneContratto',
      label: <TranslatedText i18nKey="common.contracts"/>,
      placeholder: <TranslatedText i18nKey="cases.contract-select.select-contract"/>,
      loading: <TranslatedText i18nKey="cases.contract-select.loading"/>,
      noContractFound: <TranslatedText i18nKey="cases.contract-select.no-contract-found"/>,
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required"/>,
      type: 'active-contract-select',
      startEventDataLayer : startEventDataLayer,
      excludeStatusTypes: ['inactive'],
      onSelected: (selected, values, setFieldValue, setFieldTouched) => {
        setFieldValue(signValue.name, sign);
        setFieldValue("comune", selected.city || "");
        setFieldValue("via", `${selected.street || ""} , ${selected.streetNumber || ""}`);
        setFieldValue("integraClientCode", selected.clientCode || "");
        setFieldValue("address", `${selected.accountHolder?.address?.street || ""} ${selected.accountHolder?.address?.streetNumber || ""} ${selected.accountHolder?.address?.city || ""}`);
        setFieldTouched("comune", false);
        setFieldTouched("via", false);
        setFieldTouched("integraClientCode", false);
        setFieldTouched("address", false);
        if (selected.accountHolder) {
          setFieldValue("nominativo", selected.accountHolder.businessName || "");
          setFieldValue("fiscalCode", selected.accountHolder.fiscalCode || "");
          setFieldValue("vatNumber", selected.accountHolder.vatNumber || "");

          setFieldTouched("nominativo", false);
          setFieldTouched("fiscalCode", false);
          setFieldTouched("vatNumber", false);
        }
      },
    },
    comune: {
      name: 'comune',
      label: <TranslatedText i18nKey="cases.request_info.fields.comune.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required'/>,
      type: 'input',
      disabled: true,
    },
    via: {
      name: 'via',
      label: <TranslatedText i18nKey="cases.request_info.fields.via.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required'/>,
      type: 'input',
      disabled: true,
    },
    //step 1.2
    signValue: {
      name: "signValue",
      label: <TranslatedText i18nKey="cases.request_info.fields.sign.label"/>,
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder"/>
      ),
      invalidErrorMsg: <TranslatedText i18nKey="common.select"/>,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required"/>
      ),
      type: "input",
    },
    nominativo: {
      name: "nominativo",
      label: <TranslatedText i18nKey="cases.request_info.fields.name_and_surname.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required'/>,
      type: "input",
      readonly: true,
    },
    integraClientCode: {
      name: 'integraClientCode',
      label: <TranslatedText i18nKey="cases.lettura_sicura.attiva.codiceCliente.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required'/>,
      type: 'input',
      readonly: true,
    },
    fiscalCode: {
      name: 'fiscalCode',
      label: <TranslatedText i18nKey="cases.request_info.fields.codiceFiscale.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required'/>,
      type: 'input',
      readonly: true,
    },
    vatNumber: {
      name: 'vatNumber',
      label: <TranslatedText i18nKey="dashboard.impersonation.table.partita_iva"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required'/>,
      type: 'input',
      readonly: true,
    },
    address: {
      name: "address",
      label: <TranslatedText i18nKey="cases.request_info.fields.indirizzo.label"/>,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.required"/>,
      type: "input",
      readonly: true,
    },
    telefono: {
      name: "telefono",
      label: <TranslatedText i18nKey="cases.request_info.fields.telefono.label.required"/>,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder"/>,
      invalidErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.telefono.invalid"/>,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required"/>
      ),
      type: "input",
    },
    email: {
      name: "email",
      label: <TranslatedText i18nKey="cases.request_info.fields.email.label.required"/>,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder"/>,
      invalidErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.email.invalid"/>,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required"/>
      ),
      type: "input",
    },
    confirmEmail: {
      name: "confirmEmail",
      label: <TranslatedText i18nKey="cases.digitalization.confirm"/>,
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder"/>
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.email.invalid"/>
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required"/>
      ),
      type: "input",
      onCopy: true,
      onPaste: true,
    },

    //step 1.3

    userNominativo: {
      name: "userNominativo",
      label: <TranslatedText i18nKey="cases.request_info.fields.name_and_surname.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required'/>,
      labelIcon: <i
        className="gc-icon-thick-info"
        aria-hidden="true"
        style={{fontSize: "20px"}}
      />,
      infoModalMessage: <TranslatedText i18nKey="cases.businessName.popup.message"/>,
      onChange: (setFieldValue, onChange, e) => {
        setFieldValue(userFiscalCode.name, "");
        onChange(e);
      },
      type: "input",
    },
    userFiscalCode: {
      name: 'userFiscalCode',
      label: <TranslatedText i18nKey="cases.request_info.fields.codiceFiscale.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required'/>,
      type: 'input',
      uppercase: true
    },
    userAddress: {
      name: "userAddress",
      label: <TranslatedText i18nKey="cases.request_info.fields.indirizzo.label"/>,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.required"/>,
      type: "egon-address",
      suggestionType: "address",
      onError: (value, setFieldValue) => {
        setFieldValue(userAddress.name, value);
      },
      onChange: (setFieldValue, value) => {
        setFieldValue(userAddress.name, value);
      },
      onSelect: (components, setFieldValue, egonCodeResponse) => {
        const isStreetValid = (typeof components.civico !== 'undefined') && (typeof components.via !== 'undefined');
        setFieldValue(userAddress.name, isStreetValid ?  `${components.via}, ${components.civico}, ${components.comune}` : '');
        egonCodeResponse.tipo_Indirizzo="domiciliazione";
        userAddress.egonCodeResponse=egonCodeResponse;
      },
      step : 1,
    },
    userTelefono: {
      name: "userTelefono",
      label: <TranslatedText i18nKey="cases.request_info.fields.telefono.label.required"/>,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder"/>,
      invalidErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.telefono.invalid"/>,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required"/>
      ),
      type: "input"
    },
    userEmail: {
      name: "userEmail",
      label: <TranslatedText i18nKey="cases.request_info.fields.email.label.required"/>,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder"/>,
      invalidErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.email.invalid"/>,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required"/>
      ),
      type: "input",
    },

    //step 2
    bankName: {
      name: "bankName",
      label: <TranslatedText i18nKey="cases.voltura.domicialiazone.nome_banca.label"/>,
      placeholder: <TranslatedText i18nKey="cases.voltura.domicialiazone.nome_banca.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.required"/>,
      type: "input",
      readonly: true
    },
    agencia: {
      name: "agencia",
      label: <TranslatedText i18nKey="cases.voltura.domicialiazone.agenzia.label"/>,
      placeholder: <TranslatedText i18nKey="cases.voltura.domicialiazone.agenzia.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.required"/>,
      type: "input",
      readonly: true
    },
    iban: {
      name: 'iban',
      labelButton: <TranslatedText i18nKey="cases.voltura.iban.labelButton.validation.text"/>,
      label: <TranslatedText i18nKey="cases.voltura.iban.label"/>,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.required"/>,
      modalInfoContent: <TranslatedText i18nKey="cases.voltura.iban.modalInfoContent"/>,
      modalInfoButtonText: <TranslatedText i18nKey="cases.voltura.iban.modalInfoButtonText"/>,
      relatedInfo: [
        {'bankName': 'bankName'},
        {'agency': 'agencia'}
      ],
      type: 'iban',
      uppercase: true
    }
  }
}

const {
  formField: {
    nominativo,
    integraClientCode,
    fiscalCode,
    vatNumber,
    address,
    signValue,
    telefono,
    confirmEmail,
    email,
    userNominativo,
    userFiscalCode,
    userAddress,
    userTelefono,
    userEmail,
    selezioneContratto,
    comune,
    via,
    bankName,
    agencia,
    iban,
  },
} = model;


const initialValues = {
  [nominativo.name]: "",
  [integraClientCode.name]: "",
  [fiscalCode.name]: "",
  [vatNumber.name]: "",
  [address.name]: "",
  [telefono.name]: "",
  [email.name]: "",
  [confirmEmail.name]: "",
  [userNominativo.name]: "",
  [userFiscalCode.name]: "",
  [userAddress.name]: "",
  [userTelefono.name]: "",
  [userEmail.name]: "",
  [selezioneContratto.name]: "",
  [comune.name]: "",
  [via.name]: "",
  [iban.name]: "",
  [agencia.name]: "",
  [bankName.name]: "",
  [signValue.name]: "",  
};


const getValidationSchema = () => {
  const validationBusinessName = getValidationObject("businessName");

  return [
    Yup.object().shape({
      [userNominativo.name]: Yup.string().required(userNominativo.requiredErrorMsg)
        .matches(validationBusinessName.regex
          , {
            message: (
              <TranslatedText i18nKey={validationBusinessName?.message_key || ""}/>
            ),
          })
        ,
      [userFiscalCode.name]: Yup.string().required(userFiscalCode.requiredErrorMsg),
      [userAddress.name]: Yup.string().required(userAddress.requiredErrorMsg),
      [userTelefono.name]: Yup.number()
        .typeError(<TranslatedText i18nKey="phone_mobile_not_valid_error_message"/>)
        .required(userTelefono.requiredErrorMsg),
      [userEmail.name]: Yup.string()
        .email(userEmail.invalidErrorMsg)
        .required(userEmail.requiredErrorMsg),
      [confirmEmail.name]: Yup.string().when([signValue.name], {
        is: (signValue) => {
          return signValue === true
        },
        then: Yup.string()
          .oneOf(
            [Yup.ref(userEmail.name), null],
            <TranslatedText i18nKey="cases.request_info.email.match"/>
          )
          .required(confirmEmail.requiredErrorMsg),
      })
    }),
    Yup.object().shape({}),
    Yup.object().shape({
      [iban.name]: Yup.string()
        .required(iban.requiredErrorMsg)
        .min(27, (<TranslatedText i18nKey="cases.domiciliazone_bancaria.iban_characters_length"/>))
        .max(27, (<TranslatedText i18nKey="cases.domiciliazone_bancaria.iban_characters_length"/>))
        .matches(/[A-Z]/, {
          message: (
            <TranslatedText i18nKey="cases.domiciliazone_bancaria.iban_characters_check"/>
          ),
        })
        .matches(/IT[A-Z0-9]{2}\s?/, {
          message: (
            <TranslatedText i18nKey="cases.domiciliazone_bancaria.iban_digits"/>
          )
        })
      ,
    }),
  ]
}


const getLayout = (privacyLink, privacyCtaLabel) => {
  return ([
   
    {
      chapter: true,
      chapterName: "",
      title: <TranslatedText i18nKey="formWizard.step_1.2.title"/>,
      fields: [
        {
          fieldName: userNominativo.name,
          grid: {
            xs: 12,
            md: 6,
          }
        },
        {
          fieldName: userFiscalCode.name,
          grid: {
            xs: 12,
            md: 6,
          }
        },
        {
          fieldName: userAddress.name,
          grid: {
            xs: 12,
            md: 12,
          }
        },
        {
          fieldName: userTelefono.name,
          grid: {
            xs: 12,
            md: 6,
          }
        },
        {
          fieldName: null,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: null,
          text: (<SignDigitalTitleEmailContent
            label={<TranslatedText i18nKey="domicilizazione_bancaria.firma_digitale.title.emails.part"/>}/>),
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: userEmail.name,
          grid: {
            xs: 12,
            md: 6,
          }
        },
        {
          fieldName: confirmEmail.name,
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "signValue",
              is: true
            }
          ],
        },
        {
          fieldName: null,
          text: (
            <InfoLabel
              label={<TranslatedText i18nKey="cases.confirm.email.info"/>}
            />
          ),
          grid: {
            xs: 12,
          },
          condition: [
            {
              if: "signValue",
              is: true
            }
          ],
        },
      ],
    },
    {
      chapter: false,
      noMandatoryLegend: true,
      title: (
        <TranslatedText i18nKey="cases.voltura.layout.informativa_privacy.chapter_name" />
      ),
      fields: [],
      content: (
        <div>
          <p>
            <PrivacyPolicy privacyLink={privacyLink} privacyCtaLabel={privacyCtaLabel}/>
          </p>
        </div>
      ),
    },
    {
      chapter: true,
      chapterName: <TranslatedText i18nKey="cases.voltura.layout.domiciliazone_bancaria.chapter_name"/>,
      title: <TranslatedText i18nKey="cases.voltura.layout.domiciliazone_bancaria.title"/>,
      fields: [
        {
          fieldName: iban.name,
          grid: {
            xs: 12,
            md: 12,
          },
        },
        {
          fieldName: bankName.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: agencia.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },

      ],
    },
  ])
}

const getSummaryLayout = (privacyLink, privacyCtaLabel) => {
  return ([
    {
      noModify: true,
      chapter: true,
      chapterName: <TranslatedText i18nKey="tutelaPerdite.step_1.chapter"/>,
      title: <TranslatedText i18nKey="tutelaPerdite.step_1.title"/>,
      fields: [
        {
          fieldName: "selezioneContratto",
          grid: {
            xs: 12,
            md: 8,
          },
        },
        {
          fieldName: "comune",
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: "via",
          grid: {
            xs: 12,
            md: 6,
          },
        },
      ],
    },
    {
      noModify: true,
      chapter: false,
      chapterName: "",
      title: <TranslatedText i18nKey="formWizard.step_1.1.title"/>,
      fields: [
        {
          fieldName: nominativo.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: integraClientCode.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: fiscalCode.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: vatNumber.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: address.name,
          grid: {
            xs: 12,
            md: 12,
          },
        },
        {
          fieldName: telefono.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: email.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
      ],
    },
    {
      chapter: false,
      noSummaryModal: true,
      summaryCustomActiveStep: -2,
      onModify: (setFieldValue) => {
        setFieldValue(userTelefono.name, "");
        setFieldValue(userEmail.name, "");
        setFieldValue(confirmEmail.name, "");
      },
      chapterName: "",
      title: <TranslatedText i18nKey="formWizard.step_1.2.title"/>,
      fields: [
        {
          fieldName: userNominativo.name,
          grid: {
            xs: 12,
            md: 6,
          }
        },
        {
          fieldName: userFiscalCode.name,
          grid: {
            xs: 12,
            md: 6,
          }
        },
        {
          fieldName: userAddress.name,
          grid: {
            xs: 12,
            md: 12,
          }
        },
        {
          fieldName: userTelefono.name,
          grid: {
            xs: 12,
            md: 6,
          }
        },
        {
          fieldName: null,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: null,
          text: (<SignDigitalTitleEmailContent
            label={<TranslatedText i18nKey="domicilizazione_bancaria.firma_digitale.title.emails.part"/>}/>),
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: userEmail.name,
          grid: {
            xs: 12,
            md: 6,
          }
        },
        {
          fieldName: confirmEmail.name,
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "signValue",
              is: true
            }
          ],
        },
        {
          fieldName: null,
          text: (
            <InfoLabel
              label={<TranslatedText i18nKey="cases.confirm.email.info"/>}
            />
          ),
          grid: {
            xs: 12,
          },
          condition: [
            {
              if: "signValue",
              is: true
            }
          ],
        },
      ],
    },
    {
      chapter: false,
      noSummaryModal: true,
      summaryCustomActiveStep: -2,
      title: (
        <TranslatedText i18nKey="cases.voltura.layout.informativa_privacy.chapter_name" />
      ),
      fields: [],
      content: (
        <div>
          <p>
            <PrivacyPolicy privacyLink={privacyLink} privacyCtaLabel={privacyCtaLabel}/>
          </p>
        </div>
      ),
    },
    {
      chapter: true,
      noSummaryModal: true,
      summaryCustomActiveStep: -2,
      onModify: (setFieldValue) => {
        setFieldValue(iban.name, "");
        setFieldValue(bankName.name, "");
        setFieldValue(agencia.name, "");
      },
      chapterName: <TranslatedText i18nKey="cases.voltura.layout.domiciliazone_bancaria.chapter_name"/>,
      title: <TranslatedText i18nKey="cases.voltura.layout.domiciliazone_bancaria.title"/>,
      fields: [
        {
          fieldName: iban.name,
          grid: {
            xs: 12,
            md: 12,
          },
        },
        {
          fieldName: bankName.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: agencia.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },

      ],
    },
  ])
}
const getFormDetails = (digitalization = null) => { 
  return {
    title: <TranslatedText i18nKey="cases.domiciliazione_bancaria.title"/>,
    description: digitalization ? <TranslatedText i18nKey={"cases.domiciliazione_bancaria.description"}/> : (
      <>
      <span
        className="gc-icon-functional-doc-pdf-2-col"
        style={{verticalAlign: "bottom"}}
      >
        <span className="path1"/>
        <span className="path2"/>
      </span>{" "}
        {<TranslatedText i18nKey="cases.voltura.description.info"/>}
      </>
    ),
    summary: true,
    executeBeforeSubmitOnLastStep: true,
    backTo: '/dashboard',
    stepper: CaseStepperType.Full,
    autoOpenHelpModal: !digitalization,
    backToText: <TranslatedText i18nKey="common.home"/>,
    blockIfNoContracts: true,
    blockText: (
      <div className="content">
        <p>
          <TranslatedText i18nKey="cases.modal.contracts.block_text"/>
        </p>
      </div>
    ),
    helpText: digitalization ? null : (
      <div className={"content"}>
        <p>
          <TranslatedText i18nKey="cases.request_info.form_wizard.helpText"/>
        </p>
        <p>
          <TranslatedText i18nKey="cases.form_wizard.help_text_3"/>
        </p>
        <ul>
          <li>
            <TranslatedText i18nKey="cases.complex.success.pdf.li1"/>{' '}
            <a className="link" href={`mailto:fondoperdite@gruppocap.it`}>
              fondoperdite@gruppocap.it
            </a>
          </li>
          <li>
            <TranslatedText i18nKey="cases.complex.success.pdf.li2.firt_part"/>{' '}
            <span className="bold"><TranslatedText i18nKey="cases.complex.success.pdf.li2.name"/></span>{' '}
            <TranslatedText i18nKey="cases.complex.success.pdf.li2.last_part"/>
          </li>
          <li>
            <TranslatedText i18nKey="cases.complex.success.pdf.li3.fax"/> {' '}
            <span className="bold">
            <TranslatedText i18nKey="cases.complex.success.pdf.li3.fax_number"/>
          </span>
          </li>
        </ul>
        <p><TranslatedText i18nKey="cases.voltura.help_text_2"/></p>
      </div>
    ),
    incompleteActivation: false,
    successText: (
      <>
        <p>
          <TranslatedText i18nKey="cases.complex.success.pdf"/>
        </p>
        <ul>
          <li>
            <TranslatedText i18nKey="cases.complex.success.pdf.li1"/>{' '}
            <a className="link" href={`mailto:fondoperdite@gruppocap.it`}>
              fondoperdite@gruppocap.it
            </a>
          </li>
          <li>
            <TranslatedText i18nKey="cases.complex.success.pdf.li2.firt_part"/>{' '}
            <span className="bold"><TranslatedText i18nKey="cases.complex.success.pdf.li2.name"/></span>{' '}
            <TranslatedText i18nKey="cases.complex.success.pdf.li2.last_part"/>
          </li>
          <li>
            <TranslatedText i18nKey="cases.complex.success.pdf.li3.fax"/> {' '}
            <span className="bold">
            <TranslatedText i18nKey="cases.complex.success.pdf.li3.fax_number"/>
          </span>
          </li>
        </ul>
        <p><TranslatedText i18nKey="cases.complex.success.pdf_part_1"/></p>
      </>
    ),
  }
}


const punctualizationMapping = (payload) => {
  return {
    toSign: false,
    accountHolder: {
      integraClientCode: payload[integraClientCode.name],
      vatNumber: payload[vatNumber.name],
      fiscalCode: payload[fiscalCode.name],
      businessName: payload[nominativo.name],
      contactsInfo: {
        email: payload[email.name] || "",
        phoneNumber: payload[telefono.name] || "",
      },
      address: {
        street: payload[via.name].split(",")[0] || "",
        streetNumber: payload[via.name].split(",")[1] || "",
        city: payload[comune.name],
      }
    },
    bankProfile: {
      businessName: payload[userNominativo.name],
      fiscalCode: payload[userFiscalCode.name],
      address: payload[userAddress.name],
      email: payload[userEmail.name],
      phoneNumber: payload[userTelefono.name],
    },
    bankData: {
      IBAN: payload[iban.name],
      bankName: payload[bankName.name],
      branchName: payload[agencia.name],
    },
    currentContract: {
      contractId: payload[selezioneContratto.name],
    },
    addressList : [
      model.formField.userAddress.egonCodeResponse,
    ].filter(element => element !== undefined && element !== null),
    updateBankDomiciliation: true,
    draft: false,
    type: ComplexCaseType.BANK_DOMICILIATION,
  };
};

const translatedMapping = (payload, excludeProperties) => {
  if (excludeProperties) {
    return punctualizationMapping(payload);
  }
  return {
    toSign: true,
    accountHolder: {
      integraClientCode: payload[integraClientCode.name],
      vatNumber: payload[vatNumber.name],
      fiscalCode: payload[fiscalCode.name],
      businessName: payload[nominativo.name],
      contactsInfo: {
        email: payload[email.name] || "",
        phoneNumber: payload[telefono.name] || "",
      },
      address: {
        street: payload[via.name].split(",")[0] || "",
        streetNumber: payload[via.name].split(",")[1] || "",
        city: payload[comune.name],
      }
    },
    bankProfile: {
      businessName: payload[userNominativo.name],
      fiscalCode: payload[userFiscalCode.name],
      address: payload[userAddress.name],
      email: payload[userEmail.name],
      phoneNumber: payload[userTelefono.name],
    },
    digitalSign: {
      email: payload[userEmail.name]
    },
    bankData: {
      IBAN: payload[iban.name],
      bankName: payload[bankName.name],
      branchName: payload[agencia.name],
    },
    currentContract: {
      contractId: payload[selezioneContratto.name],
    },
    addressList : [
      model.formField.userAddress.egonCodeResponse,
    ].filter(element => element !== undefined && element !== null),
    updateBankDomiciliation: true,
    draft: false,
    type: ComplexCaseType.BANK_DOMICILIATION,
  };
};

const translatedInverseMapping = (payload, values) => {

  const mapping = {
    "req.accountHolder.integraClientCode": integraClientCode.name,
    "req.accountHolder.businessName": userNominativo.name,
    "req.accountHolder.vatNumber": vatNumber.name,
    "req.accountHolder.fiscalCode": fiscalCode.name,
    "req.accountHolder.address.street": userAddress.name.split(",")[0] || "",
    "req.accountHolder.address.streetNumber": userAddress.name.split(",")[1] || "",
    "req.accountHolder.address.city": userAddress.name.split(",")[2] || "",

    "req.accountHolder.contactsInfo.email": email.name,
    "req.accountHolder.contactsInfo.phoneNumber": telefono.name,
    "req.digitalSign.email": userEmail.name,

    "req.bankProfile.businessName": userNominativo.name,
    "req.bankProfile.fiscalCode": userFiscalCode.name,
    "req.bankProfile.address": userAddress.name,
    "req.bankProfile.email": userEmail.name,
    
    "req.bankProfile.phoneNumber": userTelefono.name,
    "req.bankData.bankName": bankName.name,
    "req.bankData.branchName": agencia.name,
    "req.bankData.IBAN": iban.name,
  };

  const errorsFields = payload.map(({field, message}) => {
    return {field, message};
  });

  return errorsFields.reduce((acc, item) => {
    acc[mapping[item.field]] = item.message;
    return acc;
  }, {});
};

const mutation = {
  type: CaseMutationType.Complex,
};

const getTrackingEventKo = () => () => {window.dataLayer.push({"event": "pratica", "tipo": CaseForms.DomiciliazioneBancariaComplex, "step": "invio_richiesta", "esito": "KO"})}
const getTrackingEvent = () => () => {window.dataLayer.push({"event": "pratica", "tipo": CaseForms.DomiciliazioneBancariaComplex, "step": "invio_richiesta", "esito": "OK"})}

const main = (excludeSteps, counter, signDigital, webviewPopup, webviewRedirectPopup, buttonMatricolaContatoreCase, privacyLink, privacyCtaLabel) => {
  const summaryLayout = getSummaryLayout(privacyLink, privacyCtaLabel);
  const layout = getLayout(privacyLink, privacyCtaLabel);
  sign = signDigital;
  let validation = getValidationSchema();
  if (excludeSteps && counter < 1) {
    const stepsExcluded = excludeSteps;
    let deletedLayout = removeRequiredStep(stepsExcluded, layout);
    const {formField} = model;
    validation = removeDeletedLayoutFields(
      deletedLayout,
      formField,
      initialValues,
      validation
    );
    model = {...model, formField};
  }
  return {
    model,
    validationSchema: validation,
    initialValues,
    layout,
    formDetails: getFormDetails(sign),
    translatedMapping,
    translatedInverseMapping,
    mutation,
    trackingEventKo : getTrackingEventKo(),
    trackingEvent : getTrackingEvent(),
    summaryLayout
  };
}

export default main
